import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as applicationActions from '../../actions/application';
import ImageText from '../common/imageText';
import NavigationBar from '../common/navigationBar';

class MessagePopup extends Component {
  handleOnKeyUp = (event) => {
    if (event.key === 'Enter') {
      this.props.history.push('/messages/list/read');
    }
  };

  handleClick = () => {
    this.props.history.push('/messages/list/read');
  };

  state = {
    textImage: require('./images/1361_elements.png'),
    popUpImage: require('./images/1361_Messaging_Popup.png'),
    navigationBar: {
      back: true,
      backRoute: '/messages/list/read',
      mainMenu: true,
      navigate: true,
    },
  };

  componentWillMount() {
    document.addEventListener('keyup', this.handleOnKeyUp, false);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.handleOnKeyUp);
  }

  render() {
    return (
      <div className="messages-list">
        <ImageText id="text" src={this.state.textImage} />
        <ImageText id="text" src={this.state.popUpImage} onClick={this.handleClick} />
        <NavigationBar {...this.state.navigationBar} />
      </div>
    );
  }
}

const ConnectedMessagePopup = connect(
  (state) => ({
    context: state.application.currentContext,
  }),
  (dispatch) => ({
    actions: bindActionCreators(
      {
        ...applicationActions,
      },
      dispatch
    ),
  })
)(MessagePopup);

export default withRouter(ConnectedMessagePopup);
